import { apiRoutes } from 'config/apiRoutes'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

type UseDeleteProductsMutationProps = {
	onSettled: () => void
}

export const useDeleteProductsMutation = ({ onSettled }: UseDeleteProductsMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: productsDeleteMutation } = useMutation({
		mutationFn: (ids: number[]) => {
			return axiosPrivate.post(apiRoutes.productsDelete, { ids })
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
			useToast({
				type: 'success',
				message: t('Products deleted')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		productsDeleteMutation
	}
}
